angular
  .module('app')
  .controller('NewFilmController', NewFilmController);

NewFilmController.$inject = ['Session', '$state', '$stateParams', 'Films', 'Countries', '$sce'];

function NewFilmController(Session, $state, $stateParams, Films, Countries, $sce) {
  var vm = this;
  vm.filmid = $stateParams.id;
  vm.filmcat = $stateParams.categoria;
  Session.enableLoading();

  var countries = Countries.query().$promise;
  countries.then(function (res) {
    vm.countries = res;
  });

  var film = Films.get({id: vm.filmid, cat: vm.filmcat}).$promise;
  film.then(function (res) {
    res.any = parseInt(res.any, 10);
    res.durada = parseInt(res.durada, 10);
    Session.disableLoading();
    vm.film = res;
    if (!vm.film.video && vm.film.url) {
      if (vm.film.url.indexOf('youtu') >= 0) {
        var regExp = /^.*(?:(?:youtu\.be\/|v\/|vi\/|u\/\w\/|embed\/)|(?:(?:watch)?\?v(?:i)?=|&v(?:i)?=))([^#&?]*).*/;
        var match = vm.film.url.match(regExp);
        vm.videoEmbed = $sce.trustAsResourceUrl('https://www.youtube.com/embed/' + match[1]);
      } else if (vm.film.url.indexOf('vimeo') >= 0) {
        var vimeoRegex = /(?:vimeo)\.com.*(?:videos|video|channels|)\/([\d]+)/i;
        var parsed = vm.film.url.match(vimeoRegex);
        vm.videoEmbed = $sce.trustAsResourceUrl('https://player.vimeo.com/video/' + parsed[1] + '?title=0&byline=0&portrait=0');
      }
    }
  });

  vm.send = function () {
    vm.film.id = vm.filmid;
    vm.film.categoria = vm.filmcat;

    Session.enableLoading();
    var newfilm = Films.save({id: vm.filmid, cat: vm.filmcat, film: vm.film}).$promise;
    newfilm.then(function () {
      Session.disableLoading();
      Session.alert('Film data saved successfully!');
    });
  };

  vm.uploadmedia = function () {
    Session.enableLoading();
    var newfilm = Films.save({id: vm.filmid, cat: vm.filmcat, film: vm.film}).$promise;
    newfilm.then(function () {
      Session.disableLoading();
      $state.go('dashboard.uploadmedia', {
        id: vm.filmid,
        categoria: vm.filmcat
      });
    });
  };

  vm.savepayment = function () {
    Session.enableLoading();
    var newfilm = Films.save({id: vm.filmid, cat: vm.filmcat, film: vm.film}).$promise;
    newfilm.then(function () {
      Session.disableLoading();
      $state.go('dashboard.pay', {
        id: vm.filmid,
        categoria: vm.filmcat
      });
    });
  };

  vm.film = {};

  if (!Session.id) {
    Session.go('main.index');
  }
}
